const config = {
    apiKey: 'AIzaSyBiNiMj3cVYsVg5ytrAzRzQrxm6ZyFHW20',
    authDomain: 'coveduc.firebaseapp.com',
    databaseURL: 'https://coveduc.firebaseio.com',
    projectId: 'coveduc',
    storageBucket: 'coveduc.appspot.com',
    messagingSenderId: 'YOUR_MESSAGING_SEND_ID' 
}

export { config }


// WEBPACK FOOTER //
// ./src/firebaseSecret.js